<template>
    <div class="container-fluid">
        <section v-show="eauto.eObjectType !== 'NotReady'">
            <div class="row">
                <div class="col-12">
                    <div class="card card-form">
                        <div class="card-header">
                            <div class="row">
                                <div class="col">
                                    <div class="pull-left">
                                        <h4 class="card-title float-left" v-if="eauto.id">
                                            {{$t("auto.titleAct")}}</h4>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col">
                                    <div class="alert alert-warning" v-if="eauto.eObjectType=='Waiting'">
                                        <button class="close" data-dismiss="alert">
                                            ×
                                        </button>
                                        <i class="fa-fw fa fa-warning mr-1"></i>
                                        <strong>Янги!</strong> Хали кўрилмади.
                                    </div>

                                    <div class=" alert alert-info" v-if="eauto.eObjectType=='Inprogress'">
                                        <button class="close" data-dismiss="alert">
                                            ×
                                        </button>
                                        <i class="fa-fw fa fa-info"></i>
                                        <strong>Жараён кетяпти!</strong> Кўриб чиқиляпти.
                                    </div>

                                    <div class="alert alert-success" v-if="eauto.eObjectType=='Done'">
                                        <button class="close" data-dismiss="alert">
                                            ×
                                        </button>
                                        <i class="fa-fw fa fa-check"></i>
                                        <strong>Муаффақиятли баҳоланган!</strong> Тамом.
                                    </div>

                                    <div class="alert alert-danger" v-if="eauto.eObjectType=='Reject'">
                                        <button class="close" data-dismiss="alert">
                                            ×
                                        </button>
                                        <i class="fa-fw fa fa-times"></i>
                                        <strong>Бекор қилинган!</strong> Бекор қилинган.
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col d-flex gap-3">
                                    <button class="all-btn add-btn"
                                            v-if="eauto.eObjectType === 'Waiting' && hasPermission('E_BAHOLASH_AUTOS_BIND_APPRAISER')"
                                            @click="applyAppraisal()">
                                        <i class="fa fa-check"></i>
                                        {{$t("realEstate.action.bindAppraiser")}}
                                    </button>

                                  <button class="all-btn btn-outline-success"
                                            v-if="eauto.eObjectType === 'Waiting' && hasPermission('E_BAHOLASH_AUTOS_BIND_APPRAISER')"
                                            @click="bindToComplement()">
                                    <i class="fa fa-check me-1"></i>
                                        {{$t("realEstate.action.bindComplement")}}
                                  </button>

                                  <button class="all-btn delete-btn ml-2"
                                            v-if="eauto.eObjectType === 'Waiting' && hasPermission('E_BAHOLASH_AUTOS_REJECT')"
                                            @click="showReject">
                                        <i class="fa fa-reply"></i>
                                        {{$t("realEstate.action.pending")}}
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-12 col-md-6">
                                    <div class="form-group">
                                        <label>{{$t("realEstate.field.ownerClient")}}</label>
                                        <div class="form-control">
                                            <div v-if="eauto && eauto.ownerClient">
                                                <strong>{{ eauto.ownerClient.fullName }}</strong>
                                                <span> - {{ eauto.ownerClient.firmName }} </span>
                                                <span class="badge badge-primary"
                                                      v-if="eauto.ownerClient.type === 'Legal'"> Юридик шахс</span>
                                                <span class="badge badge-primary" v-else> Жисмоний шахс</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label>{{$t("realEstate.field.name")}}</label>
                                        <div class="form-control">
                                            <span>{{ eauto.name }}</span>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label>{{$t("realEstate.field.evaluationPurpose")}}</label>
                                        <div class="form-control">
                                            <div v-if="eauto.evlGoalType === 'Predge'">Гаровга қўйиш</div>
                                            <div v-else-if="eauto.evlGoalType === 'Sale'">Сотиш учун</div>
                                            <div v-else-if="eauto.evlGoalType === 'Zero'">0 кийматда хусусийлаштириш
                                            </div>
                                            <div v-else-if="eauto.evlGoalType === 'DeterminingValue'">Бозор қийматини
                                                аниқлаш
                                            </div>
                                            <div v-else-if="eauto.evlGoalType === 'Investment'">Инвестиция қийматини
                                                аниқлаш
                                            </div>
                                            <div v-else-if="eauto.evlGoalType === 'Privatization'">Хусусийлаштириш</div>
                                            <div v-else-if="eauto.evlGoalType === 'FormationStatutoryFund'">Устав
                                                жамғармасини шакллантириш
                                            </div>
                                            <div v-else-if="eauto.evlGoalType === 'BusinessDeterminingValue'">Бизнес
                                                қийматини аниқлаш
                                            </div>
                                            <div v-else-if="eauto.evlGoalType === 'AcceptToBalance'">Балансга кабул
                                                килиш
                                            </div>
                                            <div v-else-if="eauto.evlGoalType === 'Losses'">Етказилган зарар(сотиш)
                                            </div>
                                          <div v-else-if="eauto.evlGoalType === 'DeterminationValue'">Қийматини аниқлаш
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="eauto.eObjectType=='Reject'" class="form-group">
                                        <label>{{$t("realEstate.field.rejectText")}}</label>
                                        <div class="form-control h-100">
                                            <div v-if="eauto && eauto.reasonDesc">
                                                {{ eauto.reasonDesc }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class=" col-12 col-md-6">
                                    <div class="form-group">
                                        <label>{{$t("realEstate.field.propertyType")}}</label>
                                        <div class="form-control">
                                            <div v-if="eauto.evlPropertyType === 'Private'">Хусусий мулк</div>
                                            <div v-else-if="eauto.evlPropertyType === 'Government'">Давлат мулки</div>
                                            <div v-else-if="eauto.evlPropertyType === 'Society'">Жамият мулки</div>
                                            <div v-else>Жамоа мулки</div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label>{{$t("realEstate.field.createdDate")}}</label>
                                        <div class="form-control">{{ new Date(eauto.createDate) |
                                            dateFormat('DD.MM.YYYY') }}
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label>{{$t("realEstate.field.createdBy")}}</label>
                                        <div class="form-control">
                                            <div v-if="eauto && eauto.createUserName">
                                                {{ eauto.createUserName }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label>{{$t("realEstate.field.contractAmount")}}</label>
                                        <numeric-input v-model="eauto.evlContractAmount"
                                                       :controls="false" :precision="2"
                                                       :min="120000"
                                        >
                                        </numeric-input>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-12">
                                    <div class="section-header">
                                        <h4>Автотранспортларни бахолаш учун тақдим қилинган хужжатлар</h4>
                                    </div>
                                </div>
                                <template>
                                    <PreviewDropZone
                                            code="documentsDropZone"
                                            label="Мурожат хати ёки Паспорт нусхаси"
                                            :data="eauto.letterFiles"
                                            @change="(files) => {eauto.letterFiles = files}"
                                    />

                                    <template v-if="isOwnerTypeLegal && isOrgTypeMib">
                                        <PreviewDropZone
                                                code="actOfSaleDropZone"
                                                label="realEstate.field.docActOfSale"
                                                :data="eauto.actOfSaleFiles"
                                                @change="(files) => {eauto.actOfSaleFiles = files}"
                                        />
                                        <PreviewDropZone
                                                code="decisionDropZone"
                                                label="realEstate.field.docDecision"
                                                :data="eauto.decisionFiles"
                                                @change="(files) => {eauto.decisionFiles = files}"
                                        />
                                        <PreviewDropZone
                                                code="playlistDropZone"
                                                label="realEstate.field.docPlaylist"
                                                :data="eauto.executivePlaylistFiles"
                                                @change="(files) => {eauto.executivePlaylistFiles = files}"
                                        />
                                    </template>
                                </template>
                            </div>
                            <div class="row" v-if="eauto.id && eauto.id > 0">
                                <div class="col-12">
                                    <div class="section-header">Автотранспортлар</div>
                                    <div v-for="(auto, autoIndex) in eauto.eAutoDtoList" :key="auto.id">
                                        <div class="section-header">{{ autoIndex + 1}} - автотранспорт
                                            маълумотлари
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label>{{$t("auto.name")}}</label>
                                                <div>{{ auto.name }}</div>
                                            </div>
                                        </div>
                                      <div class="row">
                                        <div class="col-md-6">
                                          <div class="form-group">
                                            <label>{{ $t("auto.autoTexPassport.governmentNum") }}</label>
                                            <div class="form-control">
                                              <span>{{ auto.autoDto.governmentNum }}</span>
                                            </div>
                                          </div>
                                        </div>
                                        <div class="col-md-6">
                                          <div class="form-group">
                                            <label>{{ $t("auto.autoTexPassport.texPassportNumber") }}</label>
                                            <div class="form-control">
                                              <span>{{ auto.autoDto.texPassportNum }}</span>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                        <PreviewDropZoneEAppraisal
                                                code="texPassportDropZone"
                                                label="auto.texPassport"
                                                :data="auto.texPassportFiles"
                                                @change="(texPassportFiles) => {auto.texPassportFiles = texPassportFiles}"
                                        />
                                        <PreviewDropZoneEAppraisal
                                                code="autoPhotoDropZone"
                                                label="auto.photos"
                                                :data="auto.carsViewPicture"
                                                @change="(autoPhotos) => {auto.carsViewPicture = autoPhotos}"
                                        />
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label>{{$t("building.field.description")}}</label>
                                                <div class="form-control h-100">{{ auto.aboutAuto }}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <template>
                <b-modal v-model="show" title="Автони бекор қилиш">
                    <div class="container-fluid">
                        <div class="form-group">
                            <label>Бекор қилиш сабабини киритинг<span class="red">*</span></label>
                            <textarea class="form-control"
                                      v-model="eauto.reasonDesc">
                        </textarea>
                        </div>
                    </div>
                    <div slot="modal-footer">
                        <button
                                type="button"
                                class="all-btn add-btn float-right ml-2"
                                @click="rejectAppraisal()"
                        >{{$t("action.save")}}
                        </button>
                        <button
                                type="button"
                                class="all-btn delete-btn float-right"
                                @click="rejectModalHide"
                        >{{$t("action.cancel")}}
                        </button>
                    </div>
                </b-modal>
            </template>
        </section>
        <section v-show="eauto.eObjectType === 'NotReady'">
            <div class="row">
                <div class="col-12">
                    <div class="card card-form">
                        <div class="card-header">
                            <div class="row">
                                <div class="col">
                                    <button class="all-btn add-btn"
                                            v-if="!createUser || !createUser.id"
                                            @click="bindAgent"
                                    >
                                        <i class="fa fa-check"></i>
                                        {{$t("realEstate.action.bindAgent")}}
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-12">
                                    <div class="form-group">
                                        <label>{{$t("report.field.agents")}}</label>
                                        <v-select v-model="createUser" label="text"
                                                  :options="agents"
                                                  :filterable="false"
                                                  @search="onUsersSearch"
                                                  @search:focus="onUsersFocus">
                                            <template slot="option" slot-scope="option" v-if="option">
                                                <div v-html="option.name"></div>
                                            </template>
                                            <template slot="selected-option"
                                                      v-if="createUser && createUser.name">
                                                <div v-html="createUser.name"
                                                     @click="$eventBus.$emit('search:focus')"></div>
                                            </template>
                                            <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                                        </v-select>
                                        <div class="red" v-if="$v.createUser.$error">
                                            {{$t("realEstate.field.agent")}}
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label>{{$t("realEstate.field.address")}}</label>
                                        <div class="form-control">
                                            <div v-if="eauto.ownerClient && eauto.ownerClient.address">
                                                <strong>{{ eauto.ownerClient.address }}</strong>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label>{{$t("finance.field.phoneNumber")}}</label>
                                        <div class="form-control">
                                            <div v-if="eauto && eauto.apiOrderDto">
                                                <strong>{{ eauto.apiOrderDto.mobilePhone }}</strong>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>

    import PreviewDropZoneEAppraisal from "@/views/real-estate/PreviewDropZoneEAppraisal";
    import PreviewDropZone from '@/views/real-estate/PreviewDropZone'
    import bModal from 'bootstrap-vue/es/components/modal/modal'
    import initFilterModel from '@/shared/filter';
    import {requiredUnless} from 'vuelidate/lib/validators';

    export default {
        name: "EAutoView",
        components: {
            PreviewDropZone,
            PreviewDropZoneEAppraisal,
            'b-modal': bModal
        },
        data() {
            return {
                processing: false,
                show: false,
                eauto: {
                    reasonDesc: '',
                    evlContractAmount: 0
                },
                filter: initFilterModel(),
                agents: [],
                createUser: {}
            }
        },
        validations() {
            return {
                createUser: {
                    required: requiredUnless(() => {
                        return !(this.eauto.eObjectType === 'NotReady');
                    })
                }
            }
        },
        methods: {
            init() {
                const vm = this;
                const id = this.$route.params.id;
                if (id && id > 0) {
                    this.$http.get('/e-appraisal/auto/' + id)
                        .then(res => {
                            vm.eauto = res.data;
                            vm.createUser = {
                                id: res.createUserId
                            };
                            this.processing = false;
                        }, () => {
                            this.$swal({
                                title: this.$t('messages.common.error'),
                                text: this.$t('messages.fixedExpense.error'),
                                type: 'error'
                            });
                            this.processing = false;
                        })

                }
            },
            applyAppraisal() {
                const vm = this;
                vm.processing = true;
                this.$http.get('e-appraisal/auto/assigned-appraisal/' + vm.eauto.id)
                    .then(res => {
                        if (res && res.data && res.data.status === 'SUCCESS') {
                            this.$router.push('/e-appraisal/auto/list');
                        } else {
                            this.$swal({
                                title: this.$t('messages.common.warning'),
                                text: this.$t(res.data.message),
                                type: 'warning'
                            });
                        }
                        vm.processing = false;
                    }, () => {
                        this.$swal({
                            title: this.$t('messages.common.error'),
                            text: this.$t('messages.common.errorOccurred'),
                            type: 'error'
                        });
                        vm.processing = false;
                    })
            },

             rejectAppraisal() {
                if (this.eauto.reasonDesc) {
                    this.processing = true;
                    const data={
                        rejectObjectId: this.eauto.id,
                        comment: this.eauto.reasonDesc
                    };
                    this.$http.post('e-appraisal/auto/status/reject', data)
                        .then(res => {
                        if (res && res.data && res.data.status === 'SUCCESS') {
                            this.$router.push('/e-appraisal/auto/list');
                        } else {
                            this.$swal({
                                title: this.$t('messages.common.warning'),
                                text: this.$t('asset.statusWarning'),
                                type: 'warning'
                            });
                        }
                        this.processing = false;
                    }, () => {
                        this.$swal({
                            title: this.$t('messages.common.error'),
                            text: this.$t('asset.statusError'),
                            type: 'error'
                        });
                        this.processing = false;
                    })
                } else {
                    this.$swal({
                        title: 'Хабар!',
                        text: 'Бекор қилиш сабабини киритинг!',
                        type: 'warning'
                    });
                }
            },
            showReject() {
                this.eauto.reasonDesc = '';
                this.show = true;
            },
            rejectModalHide() {
                this.show = false;
            },
            onUsersSearch(searchTxt, loading) {
                loading(true);
                this.agents = [];
                this.filter.search = searchTxt;
                this.$http.post('user/agent', this.filter)
                    .then(res => {
                        this.agents = res.data.data;
                        loading(false);
                        this.filter.search = '';
                    }, err => {
                        console.log(err);
                        loading(false);
                    });
            },
            onUsersFocus() {
                this.agents = [];
                this.filter.search = '';
                this.$http.post('user/agent', this.filter)
                    .then(res => {
                        this.agents = res.data.data;
                    }, err => {
                        console.log(err);
                    });
            },
            bindAgent() {
                this.$v.$touch();
                if (this.$v.$invalid) {
                    return;
                }

                this.processing = true;

                if (this.createUser) {
                    this.eauto.createUserId = this.createUser.id
                }

                this.$http.post('e-appraisal/auto/bind-agent', this.eauto).then(res => {
                    if (res && res.data && res.data.status === 'SUCCESS') {
                        this.$swal({
                            title: this.$t('messages.common.success'),
                            text: this.$t('messages.auto.statusSuccess'),
                            type: 'success'
                        });
                        this.$router.push('/e-appraisal/auto/list');
                    } else {
                        this.$swal({
                            title: this.$t('messages.common.warning'),
                            text: this.$t(res.data.message),
                            type: 'warning'
                        });
                    }
                    this.processing = false;
                }, () => {
                    this.$swal({
                        title: this.$t('messages.common.error'),
                        text: this.$t('messages.auto.statusError'),
                        type: 'error'
                    });
                    this.processing = false;
                })
            },
          bindToComplement() {
            const vm = this;
            vm.processing = true;
            this.$http.get('e-appraisal/auto/bind-complement/' + vm.eauto.id)
                .then(res => {
                  if (res && res.data && res.data.body && res.data.body.status === 'SUCCESS') {
                    this.$router.push('/e-appraisal/auto/list');
                  } else {
                    this.$swal({
                      title: this.$t('messages.common.warning'),
                      text: this.$t(res.data.message),
                      type: 'warning'
                    });
                  }
                  vm.processing = false;
                }, () => {
                  this.$swal({
                    title: this.$t('messages.common.error'),
                    text: this.$t('messages.common.errorOccurred'),
                    type: 'error'
                  });
                  vm.processing = false;
                })
          }
        },
        created() {
            this.filter.province = null;
            this.init();
        },
        computed: {
            isOwnerTypeLegal() {
                return !!(this.eauto.ownerClient && this.eauto.ownerClient.type && this.eauto.ownerClient.type === 'Legal');
            },
            isOrgTypeMib() {
                return !!(this.eauto.ownerClient && this.eauto.ownerClient.organizationType &&
                    (this.eauto.ownerClient.organizationType === 'BUREAU_OF_COMPULSORY_EXECUTION' || this.eauto.ownerClient.organizationType === 'CUSTOMS_ADMINISTRATION'));
            }
        }
    }
</script>

<style scoped>

</style>